<template>
  <div class="timer">
    {{ timer }}
  </div>
</template>

<script>
export default {
  props: {
    time: { type: String, default: '', required: true },
  },

  data() {
    return {
      startTime: null,
      timerIntervalFunc: null,
      timer: '',
    };
  },

  mounted() {
    clearInterval(this.timerIntervalFunc);
    this.updateTimer();
  },

  beforeUnmount() {
    this.startTime = null;
    clearInterval(this.timerIntervalFunc);
  },

  methods: {
    updateTimer() {
      if (this.time) {
        this.startTime = new Date(this.time).getTime();

        clearInterval(this.timerIntervalFunc);
        this.timerIntervalFunc = setInterval(() => {
          const now = new Date().getTime();
          const distance = now - this.startTime;
          const h = Math.floor(distance / 1000 / 60 / 60) % 24;
          const m = Math.floor(distance / 1000 / 60) % 60;
          const s = Math.floor(distance / 1000) % 60;

          this.timer = `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
        }, 1000);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/timer/jTimer.vue